import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type {
  ViagensControleFilters,
  ViagensControlePaginationControl,
} from 'pages/viagens-controle/types';

type State = {
  filters: ViagensControleFilters;
  paginationControl: ViagensControlePaginationControl;
};

type Actions = {
  updateFilters: (filters: ViagensControleFilters) => void;
  updatePaginationControl: (
    paginationControl: Partial<ViagensControlePaginationControl>
  ) => void;
  clearState: () => void;
};

type Options = {
  persisted?: boolean;
};

const getInitialState = (): State => ({
  filters: {},
  paginationControl: {
    page: 1,
    limit: 10,
  },
});

const createStore = (set: any) => ({
  ...getInitialState(),
  updateFilters: (filters: ViagensControleFilters) => set({ filters }),
  updatePaginationControl: (
    paginationControl: Partial<ViagensControlePaginationControl>
  ) => {
    return set((state: State) => ({
      paginationControl: {
        ...state.paginationControl,
        ...paginationControl,
      },
    }));
  },
  clearState: () => set(getInitialState()),
});

const store = create<State & Actions>(createStore);

const persistStore = create(
  persist<State & Actions>(createStore, {
    name: 'viagens-controle-search-params',
    version: 1,
  })
);

export const useViagensControleSearchParams = (options?: Options) => {
  return options?.persisted ? persistStore() : store();
};
